import React from 'react';
import { Helmet } from 'react-helmet-async';
import { SITE } from '@/config';

const Seo = ({ title, description, path = '/', jsonLd = [] }) => {
  const url = `${SITE.domain}${path === '/' ? '/' : path}`;
  const fullTitle = title.includes('|') ? title : `${title} | Provident Palm Vista Shilphata`;
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={SITE.name} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={`${SITE.domain}/assets/pdf/render-day.webp`} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={`${SITE.domain}/assets/pdf/render-day.webp`} />
      {jsonLd.map((schema, i) => (
        <script key={i} type="application/ld+json">{JSON.stringify(schema)}</script>
      ))}
    </Helmet>
  );
};

export default Seo;

export const orgSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'Provident Palm Vista – Shilphata',
  url: SITE.domain,
  telephone: '+918879856585',
  address: {
    '@type': 'PostalAddress',
    streetAddress: 'Next to Indian Oil Pump, Kalyan–Shilphata Road',
    addressLocality: 'Mumbai',
    postalCode: '421204',
    addressRegion: 'Maharashtra',
    addressCountry: 'IN',
  },
};

export const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'Provident Palm Vista Shilphata',
  url: SITE.domain,
};

export const breadcrumbSchema = (items) => ({
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: items.map((it, i) => ({
    '@type': 'ListItem',
    position: i + 1,
    name: it.name,
    item: `${SITE.domain}${it.path}`,
  })),
});

export const faqSchema = (faqs) => ({
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faqs.map((f) => ({
    '@type': 'Question',
    name: f.q,
    acceptedAnswer: { '@type': 'Answer', text: f.a },
  })),
});

export const listingSchema = {
  '@context': 'https://schema.org',
  '@type': 'RealEstateListing',
  name: 'Provident Palm Vista Shilphata – 1, 2 & 2.5 BHK Homes',
  url: SITE.domain,
  description:
    '16-acre tropical residential ecosystem on Kalyan–Shilphata Road, Mumbai with 1, 2 & 2.5 BHK homes with balconies, 70% open spaces and 60+ amenities.',
  address: {
    '@type': 'PostalAddress',
    streetAddress: 'Next to Indian Oil Pump, Kalyan–Shilphata Road',
    addressLocality: 'Mumbai',
    postalCode: '421204',
    addressRegion: 'Maharashtra',
    addressCountry: 'IN',
  },
};
